<template>
  <div>
    <mdb-input
      v-on:change="handleInput"
      :value="handlePickersValue()"
      icon="calendar"
      :label="title"
      @click.native="$refs.datePicker.open()"
    />
    <mdb-date-picker-2
      ref="datePicker"
      disabledPast
      disable-input
      v-model="datePickerValue"
      :options="options"
      :title="$t('notification_datepicker_title')"
      @close="$refs.timePicker.open()"
    />
    <mdb-time-picker-2
      ref="timePicker"
      :hoursFormat="24"
      disable-input
      auto-close
      :doneLabel="$t('done')"
      :clearLabel="$t('clear')"
      :closeLabel="$t('close')"
      v-model="timePickerValue"
    />
  </div>
</template>

<script>
import { mdbDatePicker2, mdbTimePicker2, mdbInput } from "mdbvue";
export default {
  name: "DateTimePicker",
  components: {
    mdbDatePicker2,
    mdbTimePicker2,
    mdbInput,
  },
  props: {
    dateTime: String,
    title: {
      type: String,
      default: "Valitse ajankohta",
    },
  },
  methods: {
    handleInput(val) {
      this.$emit("datetime-changed", val);
    },
    handlePickersValue() {
      let output = "";

      if (this.datePickerValue && this.timePickerValue)
        output = `${this.datePickerValue} ${this.timePickerValue}`;
      else
        output =
          this.dateTime.length > 0
            ? this.dateTime
            : this.$t("notification_pick_date");
      return output;
    },
  },
  data() {
    return {
      localDateTime: this.dateTime,
      options: {
        buttons: { ok: "Ok", clear: "Pyyhi", cancel: "Poistu" },
        week: ["MA", "TI", "KE", "TO", "PE", "LA", "SU"],
        placeholder: "Valitse ajankohta",
        month: [
          "Tammikuu",
          "Helmikuu",
          "Maaliskuu",
          "Huhtikuu",
          "Toukokuu",
          "Kesäkuu",
          "Heinäkuu",
          "Elokuu",
          "Syyskuu",
          "Lokakuu",
          "Marraskuu",
          "Joulukuu",
        ],
      },
      datePickerValue: "",
      timePickerValue: "",
    };
  },
};
</script>

<style></style>
